<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  // 监听,当路由发生变化的时候执行
  data () {
    return {
      scroll: 0
    }
  },
  watch: {
    $route (to, from) {
      // console.log(to)
      this.$cocosUtil.sendMsg({
        type: 'showClose',
        status: false
      })
      if (to.name === 'faq') {
        this.$cocosUtil.sendMsg({
          type: 'title',
          name: this.$t('faq.p1')
        })
      } else {
        let lists = [
          this.$t('faq.p2'),
          this.$t('faq.p17'),
          this.$t('faq.p58'),
          this.$t('faq.p71'),
          this.$t('faq.p88'),
          this.$t('faq.p107'),
          this.$t('faq.p154'),
          this.$t('faq.p176')
        ]
        let index = parseInt(to.params.item) - 1
        this.$cocosUtil.sendMsg({
          type: 'title',
          name: lists[index]
        })
      }

      if (to.name === 'item' && from.name === 'answer') {
        setTimeout(() => {
          document.querySelector('#app').scrollTop = parseInt(this.$store.state.scroll)
        }, 0)
      } else {
        document.querySelector('#app').scrollTop = 0
      }
    }
  }
}
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  font-family: 'PingFang SC', Helvetica, 'STHeiti STXihei', 'Microsoft YaHei', Tohoma, Arial, sans-serif;
  background-color: #f5f5f5;
}
#app::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
#app {
  width: 10rem;
  height: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 auto;
  background-color: #f5f5f5;
}
@media only screen and (max-width: 700px) {
  html,body {
    background-color: #f5f5f5;
  }
}
@media only screen and (min-width: 800px) {
  body {
    font-size: 100%!important;
  }
}

#app {
  // overflow:hidden;/* winphone8和android4+ */
  -webkit-overflow-scrolling: touch; /* ios5+ */
}
#app:after {
  min-height: calc(100% + 1px);
}

p {
  margin: 0;
  padding: 0;
  word-wrap:break-word;
}
.disnone {
  display: none;
}
.van-dialog {
  width: 288px;
}
</style>
